/**
 * Email/Password Auth HTTP Service
 *
 * The signup/login/refresh/password-reset routes are unauthenticated (they
 * mint or precede having a token), so they use plain fetch instead of
 * apiRequest.
 */

import {
  SignupInput,
  SignupOutput,
  ConfirmSignupInput,
  ConfirmSignupOutput,
  LoginInput,
  LoginOutput,
  RefreshInput,
  RefreshOutput,
  ForgotPasswordInput,
  ForgotPasswordOutput,
  ConfirmForgotPasswordInput,
  ConfirmForgotPasswordOutput,
} from "types/web-app";

const baseURL = import.meta.env.VITE_API_BASE_URL || "";

async function post<TInput, TOutput>(
  path: string,
  input: TInput,
): Promise<TOutput> {
  const res = await fetch(`${baseURL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  return res.json();
}

export const signup = (input: SignupInput) =>
  post<SignupInput, SignupOutput>("/auth/signup", input);

export const confirmSignup = (input: ConfirmSignupInput) =>
  post<ConfirmSignupInput, ConfirmSignupOutput>("/auth/confirm", input);

export const login = (input: LoginInput) =>
  post<LoginInput, LoginOutput>("/auth/login", input);

export const refresh = (input: RefreshInput) =>
  post<RefreshInput, RefreshOutput>("/auth/refresh", input);

export const forgotPassword = (input: ForgotPasswordInput) =>
  post<ForgotPasswordInput, ForgotPasswordOutput>(
    "/auth/forgot-password",
    input,
  );

export const confirmForgotPassword = (input: ConfirmForgotPasswordInput) =>
  post<ConfirmForgotPasswordInput, ConfirmForgotPasswordOutput>(
    "/auth/confirm-forgot-password",
    input,
  );
